import type { AxiosResponse } from 'axios';
import { useBetween } from '../use-between/use-between';
import { useEffect } from 'react';
import { CompanySettingsUseBetween } from '../use-between/company-settings-use-between';
import { getCompanySettings } from '../services/company-settings.service';
import CompanySettingsData from '../models/company-settings-data.model';

export default function CompanySettingsInitialize() {
    const { setCompanySettings } = useBetween(CompanySettingsUseBetween);

    const getAndSetCompanySettings = () => {
        getCompanySettings().then((response: AxiosResponse<CompanySettingsData>) => {
            const data: CompanySettingsData = response?.data;
            if (data) {
                setCompanySettings(data);
            }
        });
    };

    useEffect(() => {
        getAndSetCompanySettings();
    }, []);

    return <></>;
}
